export default "__VITE_ASSET__Bd6gYE5T__"